import { useState, useEffect, useMemo, useCallback } from 'react';
import { prop } from 'ramda';
import { useGetPlayerTags } from 'server';
import { useUserSelector } from 'js/store/hooks';
import { useIsMounted } from 'js/hooks/useIsMounted';

import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const usePlayerTags = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const fields = useDynamicReducerSelector(prop('fields'));
    const [playerTags, setPlayerTags] = useState([]);
    const hasPlayerTagFields = useMemo(() => fields.some(field => field.usePlayerTags), [fields]);
    const getPlayerTags = useGetPlayerTags();

    const fetchPlayerTags = useCallback(async () => {
        try {
            dispatch(actions.toggleLoading(true));

            const response = await getPlayerTags();

            isMounted() && setPlayerTags(response?.tags || []);
        } catch {
            isMounted() && setPlayerTags([]);
        } finally {
            isMounted() && dispatch(actions.toggleLoading(false));
        }
    }, [dispatch, getPlayerTags, isMounted, setPlayerTags]);

    useEffect(() => {
        if (!hasPlayerTagFields) {
            return;
        }

        if (isLoggedIn) {
            (async () => fetchPlayerTags())();
        } else {
            setPlayerTags([]);
        }
    }, [isLoggedIn, fetchPlayerTags, setPlayerTags, hasPlayerTagFields]);

    return [playerTags, fetchPlayerTags];
};
